/**
 * Arma el mensaje de recordatorio de cuota para el botón de WhatsApp de un
 * cliente en la guía de ruta. `formatMoneda` es la función que devuelve
 * `useFormatMoneda()`, para respetar la moneda configurada de la empresa.
 * `numeroEmpresa` (opcional) agrega una línea de contacto de la empresa,
 * ya que cada cobrador envía el mensaje desde su propio WhatsApp.
 */
export function mensajeRecordatorio(cliente, formatMoneda, numeroEmpresa) {
  const firma = numeroEmpresa ? `\n\nCualquier duda, escríbenos al ${numeroEmpresa}.` : '';

  if (!cliente.proxima_cuota_fecha) {
    return `Hola ${cliente.nombre}, te saludamos de Prestam.io. Cualquier cosa que necesites sobre tu crédito, contáctanos.${firma}`;
  }

  const monto = formatMoneda(parseFloat(cliente.proxima_cuota_monto || 0));
  const dias = cliente.proxima_cuota_dias;

  if (dias != null && dias < 0) {
    return `Hola ${cliente.nombre}, te recordamos que tu cuota #${cliente.proxima_cuota_numero} por ${monto} venció el ${cliente.proxima_cuota_fecha}. Por favor ponte al día lo antes posible. ¡Gracias!${firma}`;
  }
  if (dias === 0) {
    return `Hola ${cliente.nombre}, te recordamos que tu cuota #${cliente.proxima_cuota_numero} por ${monto} vence hoy. ¡No lo olvides!${firma}`;
  }
  return `Hola ${cliente.nombre}, te recordamos que tu cuota #${cliente.proxima_cuota_numero} por ${monto} está próxima a vencer el ${cliente.proxima_cuota_fecha}. ¡Gracias por tu pago puntual!${firma}`;
}
